var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData && _vm.modalData.open
        ? _c(
            "EmptyCardModal",
            {
              attrs: {
                modalData: _vm.modalData,
                onModalClose: (reset) => (_vm.modalData.open = false),
                onModalAccept: _vm.updateChangeQty,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("ChangeQtyBlock", {
                    ref: "changeBlock",
                    attrs: { drug: _vm.modalData.drug },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }